var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLarge = function SvgLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 260 266"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#large_svg__a)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C5D7C8",
    d: "M119.067 257.431c-61.062-5.343-106.37-58.498-101.11-118.623l6.935-79.26c.759-8.673 6.393-16.166 14.546-19.342l91.439-35.63a23.21 23.21 0 0 1 20.468 1.79l83.863 50.967c7.477 4.544 11.725 12.901 10.966 21.574l-6.934 79.261c-5.26 60.124-59.111 104.605-120.173 99.263"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C5D7C8",
    fillRule: "evenodd",
    d: "M25.705 138.135c-4.956 56.654 37.18 106.691 94.03 111.665s107.035-36.987 111.992-93.64l6.878-78.616a15.31 15.31 0 0 0-7.256-14.37l-83.844-51.506a15.46 15.46 0 0 0-13.767-1.205L42.224 46.627a15.3 15.3 0 0 0-9.64 12.892zM137.31 44.783c3.175.278 5.973-2.058 6.25-5.217.276-3.16-2.074-5.946-5.249-6.224-3.176-.278-5.974 2.058-6.25 5.218-.277 3.16 2.073 5.945 5.249 6.223",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002003",
    fillRule: "evenodd",
    d: "M116.758 227.941c24.623 3.745 48.424-2.671 67.244-16.149a1.277 1.277 0 0 1 1.781.297 1.275 1.275 0 0 1-.292 1.781c-19.335 13.847-43.8 20.445-69.109 16.596-21.038-3.202-39.434-13.136-53.363-27.311a1.28 1.28 0 0 1 .012-1.806 1.276 1.276 0 0 1 1.805.018c13.556 13.796 31.452 23.459 51.922 26.574",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "large_svg__a",
    width: 260.719,
    height: 286.871,
    x: 1.542,
    y: -13.006,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_976_71451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_976_71451",
    result: "effect2_dropShadow_976_71451"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_976_71451",
    result: "shape"
  })))));
};
export default SvgLarge;